import request from '@/utils/request'

export const getTotal = (params: any) =>
  request({
    url: 'quipment/total',
    method: 'get',
    params
  })

export const getOperation = (params: any) =>
  request({
    url: 'operation/log',
    method: 'get',
    params
  })

export const getMapData = (params: any) =>
  request({
    url: 'monitor/realTime',
    method: 'get',
    params
  })

export const getIndexMapData = (params: any) =>
  request({
    url: 'storehouse/realTime',
    method: 'get',
    params
  })
